import { UserType as ApiUserType } from 'src/api/generated/touring/types';
import { UserType } from './types';

export const mapUserType = (user: ApiUserType): UserType => {
  return {
    id: user.id,
    firstname: user.firstname,
    lastname: user.lastname,
    email: user.email,
  };
};
